import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './InceptumProductNav.module.css';

const SECTIONS = [
  { id: 'about', label: 'Overview' },
  { id: 'features', label: 'Features' },
  { id: 'components', label: "What's in the Box" },
  { id: 'rules', label: 'Downloads' },
  // { id: 'creators', label: 'About the Creators' }, - commented out; may restore later
];

export default function InceptumProductNav() {
  const [activeId, setActiveId] = useState('');
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const basePath = '/inceptum';
    if (location.pathname !== basePath) return;

    const observedSections = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          observedSections.set(entry.target.id, entry);
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });

        const hasIntersectingSection = Array.from(observedSections.values()).some(
          (entry) => entry.isIntersecting
        );

        if (!hasIntersectingSection) {
          setActiveId('');
        }
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      setIsSticky(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', `/inceptum#${id}`);
    }
  };

  return (
    <nav
      className={`${styles.productNav} ${isSticky ? styles.sticky : ''}`}
      aria-label="INCEPTUM page sections"
    >
      <div className={styles.container}>
        <ul className={styles.links}>
          {SECTIONS.map(({ id, label }) => (
            <li key={id}>
              <a
                href={`/inceptum#${id}`}
                className={activeId === id ? styles.active : ''}
                onClick={(e) => handleClick(e, id)}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
